import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, InputGroup, Modal, Row, Table } from "react-bootstrap";
//import Moment from "moment";
import Select from 'react-select';
import 'react-table/react-table.css';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class EntityFindAndReplace extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            
            activeFilter: {},
            inactiveFilter: {},
            cityscopeOptions:[],
            findEntityOptions:[],
            findEntityContactsOptions:[],
            replaceEntityOptions:[],
            replaceEntityContactsOptions:[],
            replaceEntitySearchString: "",
            selectedFindEntity: null,
            findEntitySearchString: "",
            selectedReplaceEntity: null,
            showFindEntityDropDown: false,
            showReplaceEntityDropDown: false,
            findEntityMenuIsOpen: false,
            replaceEntityMenuIsOpen: false,
            salesOption: false,
            saleSheetsOption: true,
            managingAgentOption: true,
            leasingAgentOption: true,
            liftOperatorsOption: true,
            selectedScopes:[]
        };

        
        
        
        
    }
    

    async componentDidMount() {
        console.log("In EntityList componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        this.getCityscopes();
        if (this.props.entityid){
            const findEntityOptions  = await this.getEntities({ entityid: this.props.entityid, activeflag: true });
            if (findEntityOptions){
                this.setState({findEntityOptions});
                this.setState({selectedFindEntity: findEntityOptions[0]});
            }
            this.setState(state => ({
                showFindEntityDropDown: true
            }));

            const findEntityContactsOptions = await this.getEntityContacts({ entityid: this.props.entityid, activeflag: true });   
            if(findEntityContactsOptions){
                for(var i = 0; i<findEntityContactsOptions.length;i++){      
                    console.log("In find and replace loop");
                    findEntityContactsOptions[i]['map_to_entity_contact_id'] = -1;
                    findEntityContactsOptions[i]['map_to_contact'] = "Copy across";
                }
                this.setState({findEntityContactsOptions});
            }

        }

        this.setState({ isLoading: false });      
    }

    componentWillUnmount() {
        source.cancel();
    }

    async componentDidUpdate(prevProps) {
        


        if (prevProps.filter !== this.props.filter) {
            console.log("flter changed");
            const entities = await this.getEntities(this.props.filter);
            console.log(entities);
            this.setState({ entities });
        }
    }


    getEntities(filter) {
        console.log("Inside getEntities() ");
        console.log(filter);
        return API.get("colin", "/entities/dropdown", {'queryStringParameters': filter});
      
    }

    getEntityContacts(filter) {
        try {
            console.log(filter);
            return API.get("colin", `/entitycontacts/dropdown`, { 'queryStringParameters': filter, 'cancelToken': source.token });
        }
        catch{
            console.log("Error getting Entity contacts");
        }
    }

    getCityscopes() {
        try {
            API.get("colin", `/cityscopes/dropdown`, { 'cancelToken': source.token }).then((cityscopeOptions) => {
                if (cityscopeOptions) {
                    this.setState(state => ({ cityscopeOptions }));
                }
            });
        }
        catch{
            console.log("Error getting cityscopes");
        }
    }

    handleChange = event => {
        this.setState({[event.target.id]: event.target.value });
        this.setState({ modified: true });

    }   


    handleFindEntitySearch = async() => {
        try {
            
            if (this.state.showFindEntityDropDown) {
                this.setState(state => ({
                    showFindEntityDropDown: false
                }));
            }
            this.setState({selectedFindEntity: ""});
            this.setState({findEntityContactsOptions: []});
            const findEntityOptions  = await this.getEntities({ name: this.state.findEntitySearchString ,activeflag: true});
            if (findEntityOptions){             
                this.setState({findEntityOptions});
            }
            this.setState(state => ({
                showFindEntityDropDown: true
            }));                   
        }
        catch{
            alert("Error loading Entitys");
        }
    }

    handleFindEntityChange = async (selectedFindEntity) => {
        
        if (selectedFindEntity) {
            this.setState({ selectedFindEntity } );
            //Get contacts
            const findEntityContactsOptions = await this.getEntityContacts({ entityid: selectedFindEntity.value });   
            if(findEntityContactsOptions){
                for(var i = 0; i<findEntityContactsOptions.length;i++){      
                    findEntityContactsOptions[i]['map_to_entity_contact_id'] = -1;
                    findEntityContactsOptions[i]['map_to_contact'] = "Copy across";
                }
                this.setState({findEntityContactsOptions});
            }

        } else {
            this.setState({ selectedFindEntity: ""});
            
        }
        this.setState({ findEntityMenuIsOpen: false});    
    }

    handleReplaceEntityChange = async (selectedReplaceEntity) => {
        
        if (selectedReplaceEntity) {
            this.setState({ selectedReplaceEntity } );
            console.log("In handleReplaceEntityChange");
            const replaceEntityContactsOptions = await this.getEntityContacts({ entityid: selectedReplaceEntity.value });   
            if(replaceEntityContactsOptions){
                console.log(replaceEntityContactsOptions);
                
                replaceEntityContactsOptions.unshift({value: -1, label: "Copy across"});
                this.setState({replaceEntityContactsOptions});
            }
                        
        } else {
            this.setState({ selectedReplaceEntity: ""});
            
        }
        this.setState({ replaceEntityMenuIsOpen: false});    
    }

    handleReplaceEntitySearch = async() => {
        try {
            
            if (this.state.showReplaceEntityDropDown) {
                this.setState(state => ({
                    showReplaceEntityDropDown: false
                }));
            }
            
            const replaceEntityOptions  = await this.getEntities({ name: this.state.replaceEntitySearchString });
            if (replaceEntityOptions){                
                this.setState({replaceEntityOptions});
            }

            this.setState(state => ({
                showReplaceEntityDropDown: true
            }));
       

        }
        catch{
            alert("Error loading Entities");
        }
    }

    handleCheckBoxChange = event => {
        
        let name = event.target.name
        this.setState({
            [name]: event.target.checked
            , modified: true })
    }

    handleCityscopeChange = selectedScopes =>{    
        this.setState({selectedScopes});
    }

    handleFindEntityContactChange = (event, entity_contact_id) =>{
        console.log(entity_contact_id);
        let findEntityContactsOptions = [...this.state.findEntityContactsOptions];
        const index = findEntityContactsOptions.findIndex( contact => entity_contact_id === contact.value );
        findEntityContactsOptions[index].modified = true;
        if(event){                        
            findEntityContactsOptions[index]['map_to_entity_contact_id'] = event.value;
            findEntityContactsOptions[index]['map_to_contact'] = event.label;            
            this.setState({findEntityContactsOptions});   
        }
        else{
            findEntityContactsOptions[index]['map_to_entity_contact_id'] = null;
            findEntityContactsOptions[index]['map_to_contact'] = null;            
            this.setState({findEntityContactsOptions});   
        }

    }


    async executeFindAndReplace(body) {
        console.log("Inside executeFindAndReplace");
                
        return API.put("colin", `/entities/findandreplace`, {
            body: body
        });
    }

    handleFindAndReplace = async event =>{
        let confirmed =window.confirm("The find/replace process is one way and cannot be undone. Are you sure you want to proceed?");
        if (confirmed) {
            //build an array of selected scopes
            let body = {};
            let selectedScopes = [];
            for(var i =0;i<this.state.selectedScopes.length;i++){
                selectedScopes.push(this.state.selectedScopes[i].value);
            }
            body.selected_scopes = selectedScopes;
            body.selected_find_entity = this.state.selectedFindEntity.value;
            body.selected_replace_entity = this.state.selectedReplaceEntity.value;

            let contact_mapping = [];
            for(var i =0;i<this.state.findEntityContactsOptions.length;i++){
                //if(this.state.findEntityContactsOptions[i].map_to_entity_contact_id){
                    contact_mapping.push({from_entity_contact_id: this.state.findEntityContactsOptions[i].value, to_entity_contact_id: this.state.findEntityContactsOptions[i].map_to_entity_contact_id});
                
            } 
            body.contact_mapping= contact_mapping;

            body.sales =  this.state.salesOption;
            body.sale_sheets =  this.state.saleSheetsOption;
            body.managing_entity =  this.state.managingAgentOption;
            body.leasing_entity =  this.state.leasingAgentOption;
            body.lift_operators =  this.state.liftOperatorsOption;

            console.log(body);
            const result = await this.executeFindAndReplace(body);
            if (result.result === false) {
                        
                alert(result.error_message);

            }
            else {
                alert("Replace was successful. Close the Find & Replace popup to continue.");
                }
        }
    }

    
    
    renderEntities() {
        return (
            <div className="entities">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <Row >
                <Col sm={6} md={4} lg={2}>
    
                        {/* <Form.Group as={Row}  controlId="cityscopeOptions">
                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>Apply in Scopes<br/>Don't select to apply in all.</Form.Label>
                            <Col>
                            <Select
                                    value={this.state.selectedScopes}
                                    onChange={this.handleCityscopeChange}
                                    options={this.state.cityscopeOptions}
                                    onInputChange={this.handleInputChange}
                                    isMulti
                                    simpleValue
                                />
                            </Col>
                        </Form.Group> */}

                        <Form.Group as={Row} controlId="salesOption" >
                                <Col column sm={6} md={6} lg={4}></Col>
                                <Col>
                                    <Form.Check
                                        checked={this.state.salesOption}
                                        onChange={this.handleCheckBoxChange}
                                        label="Sales"
                                        type="checkbox"
                                        name="salesOption"       
                                        disabled                                                          
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="saleSheetsOption" >
                                <Col column sm={6} md={6} lg={4}></Col>
                                <Col>
                                    <Form.Check
                                        checked={this.state.saleSheetsOption}
                                        onChange={this.handleCheckBoxChange}
                                        label="Sale Sheets (current only)"
                                        type="checkbox"
                                        name="saleSheetsOption"                                                                 
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="managingAgentOption" >
                                <Col column sm={6} md={6} lg={4}></Col>
                                <Col>
                                    <Form.Check
                                        checked={this.state.managingAgentOption}
                                        onChange={this.handleCheckBoxChange}
                                        label="Managing Agents"
                                        type="checkbox"
                                        name="managingAgentOption"                                                                 
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="leasingAgentOption" >
                                <Col column sm={6} md={6} lg={4}></Col>
                                <Col>
                                    <Form.Check
                                        checked={this.state.leasingAgentOption}
                                        onChange={this.handleCheckBoxChange}
                                        label="Leasing Agents"
                                        type="checkbox"
                                        name="leasingAgentOption"                                                                 
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="liftOperatorsOption" >
                                <Col column sm={6} md={6} lg={4}></Col>
                                <Col>
                                    <Form.Check
                                        checked={this.state.liftOperatorsOption}
                                        onChange={this.handleCheckBoxChange}
                                        label="Lift Operators"
                                        type="checkbox"
                                        name="liftOperatorsOption"                                                                 
                                    />
                                </Col>
                            </Form.Group>
                       

                    </Col>

                    <Col sm={12} md={6} lg={4}>
                        

                    <Form.Group as={Row} controlId="findEntitySearchString" >
                                <Form.Label className="text-right" column sm={6} md={6} lg={3}>Find Entity</Form.Label>
                                <Col>
                                    <InputGroup size="sm" >
                                        <Form.Control
                                            onChange={this.handleChange}
                                            value={this.state.findEntitySearchString}
                                            onKeyDown={this.handleEnterOnEntitySearch}
                                            as="input"
                                            type="text"
                                            placeholder="Search entities"
                                            
                                        />
                                        <InputGroup.Append><Button onClick={this.handleFindEntitySearch} variant="outline-secondary" size="sm" type="button">Search</Button></InputGroup.Append>
                                    </InputGroup>
                                </Col>
                            </Form.Group>
                            
                            <Form.Group as={Row} controlId="selectedFindEntity" >
                                <Col column sm={6} md={6} lg={3}></Col>
                                <Col>
                                    {this.state.showFindEntityDropDown &&
                                        <div>
                                            <Select
                                                isClearable
                                                value={this.state.selectedFindEntity}
                                                onChange={this.handleFindEntityChange}
                                                options={this.state.findEntityOptions}
                                                onInputChange={this.handleInputChange}
                                                                                        
                                            />
                                            
                                        </div>
                                    }


                                    </Col>


                                </Form.Group>

                                <Row>
                                <Col sm={6} md={6} lg={3}></Col>
                                    <Col >
                                        <b>Contacts</b> -  Ignore, copy across or map to replace entity contact
                                        <Table>
                                {this.state.findEntityContactsOptions && this.state.selectedReplaceEntity && this.state.findEntityContactsOptions.map(contact =>{
                                    return(
                                        <tr key={contact.value}><td>
                                        {contact.label}</td>
                                        <td><Select
                                                isClearable
                                                value={{value: contact.map_to_entity_contact_id, label: contact.map_to_contact}}
                                                onChange={(e) => this.handleFindEntityContactChange(e,contact.value)}
                                                options={this.state.replaceEntityContactsOptions}
                                                onInputChange={this.handleInputChange}
                                                                                        
                                            /></td>
                                        </tr>
                                    )
                                }
                                )
                                }
                                </Table>
                                </Col>
                                
                                </Row>
                                    
                                    
                                
                        </Col>

                        <Col sm={12} md={6} lg={4}>
                        

                            <Form.Group as={Row} controlId="replaceEntitySearchString" >
                                        <Form.Label className="text-right" column sm={6} md={6} lg={3}>Replace Entity</Form.Label>
                                        <Col>
                                            <InputGroup size="sm" >
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                    value={this.state.replaceEntitySearchString}
                                                    onKeyDown={this.handleEnterOnEntitySearch}
                                                    as="input"
                                                    type="text"
                                                    placeholder="Search entities"
                                                    
                                                />
                                                <InputGroup.Append><Button onClick={this.handleReplaceEntitySearch} variant="outline-secondary" size="sm" type="button">Search</Button></InputGroup.Append>
                                            </InputGroup>
                                        </Col>
                                    </Form.Group>
                                    
                                    <Form.Group as={Row} controlId="selectedReplaceEntity" >
                                        <Col column sm={6} md={6} lg={3}></Col>
                                        <Col>
                                            {this.state.showReplaceEntityDropDown &&
                                                <div>
                                                    <Select
                                                        isClearable
                                                        value={this.state.selectedReplaceEntity}
                                                        onChange={this.handleReplaceEntityChange}
                                                        options={this.state.replaceEntityOptions}
                                                        onInputChange={this.handleInputChange}                                                
                                                                                             
                                                    />
                                                    
                                                </div>
                                            }


                                            </Col>


                                </Form.Group>

                               
                                
                        </Col>
                         <Col sm={6} md={4} lg={4}>
                             </Col>

                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={6} lg={4}>
                     
                        </Col>
                        <Col sm={12} md={6} lg={4}>
                           {this.state.selectedFindEntity && this.state.selectedReplaceEntity && <Button type="submit" variant="primary" onClick={this.handleFindAndReplace}>Perform Find/Replace</Button>}
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="EntityList">
            {this.props.isAuthenticated ? this.renderEntities() : console.log("error)")}
            
        </div>
    );
  }
}
